import { Action } from '@actions/types';
import { Injectable } from '@angular/core';

interface GenerateWhatsAppLinkParams {
  phone: string;
  message?: string;
  type?: string,
  app_absent?: string,
}

const WHATSAPP_BASE_URL = 'https://api.whatsapp.com/send/';

@Injectable({
  providedIn: 'root',
})
export class GenerateWhatsAppLinkAction implements Action<GenerateWhatsAppLinkParams, string> {
  run({ phone, message = '', type = 'phone_number', app_absent = '0' }: GenerateWhatsAppLinkParams): string {
    const cleanPhone = phone.replace(/\D/g, '');

    const params = new URLSearchParams({
      phone: cleanPhone,
      text: message,
      type: type,
      app_absent: app_absent,
    });

    return `${WHATSAPP_BASE_URL}?${params.toString()}`;
  }
}
